import {
	GET_USERS,
	GET_USER,
	ASSIGN_USER_TO_ROUTES,
	ASSIGN_USERS_TO_ROUTE,
	REMOVE_USER_FROM_ROUTES,
	REMOVE_USERS_FROM_ROUTES,
	GET_USERS_FOR_ROUTE,
	SYNC_USERS,
	CLEAR_USERS,
	GET_USERS_BY_ID
} from "../constants/action-types";

import Axios from "axios";

import { getApiCodes, getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();

const CancelToken = Axios.CancelToken;
let cancel;

export const GET_USER_SIZE = Object.freeze({
	SMALL: 5,
	MEDIUM: 20,
	LARGE: 50
})

/* 
    Get a list of users.
*/
export const getUsers = (callback, pageSize = GET_USER_SIZE.MEDIUM, continuationToken = null, searchText = "", cached = false) => dispatch => {
	if (cancel != null) {
		cancel()
	}

	const headers = continuationToken != null ? {
		"x-pace-continuation-token": continuationToken
	} : undefined

	adalApiFetch(Axios, searchText != "" ?
		`${API_CONFIG.URL}/search/users?searchText=${encodeURIComponent(searchText)}&pageSize=${pageSize}` :
		`${API_CONFIG.URL}/users?pageSize=${pageSize}`, {
		method: "get",
		headers: headers,
		cancelToken: new CancelToken(function executor(c) {
			// An executor function receives a cancel function as a parameter
			cancel = c;
		})
	}).then(res => {

		res.data.cached = cached
		res.data.searched = searchText != ""

		dispatch({
			type: GET_USERS,
			payload: res.data
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

/*
	Gets all users in the list of userIds
*/
export const getUsersById = (userIds, callback) => dispatch => {

	const body = {
		userIds: userIds
	}

	adalApiFetch(Axios, `${API_CONFIG.URL}/users?forIds=true`, {
		method: "post",
		data: body
	}).then(res => {

		dispatch({
			type: GET_USERS_BY_ID,
			payload: res.data
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

/*
	Clear users stored in session storage
*/
export const clearUsers = (callback) => dispatch => {
	dispatch({
		type: CLEAR_USERS,
		payload: null
	});

	callback(true);
}


/*
	Start a DB sync with AD users
*/
export const syncWithADUsers = (existingInstanceId, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/sync/users` + (existingInstanceId != null ? `/${existingInstanceId}` : ""), {
		method: existingInstanceId != null ? "get" : "post"
	}).then(res => {
		dispatch({
			type: SYNC_USERS,
			payload: res.data
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);

		if (error.response?.data?.runtimeStatus != null) {
			dispatch({
				type: SYNC_USERS,
				payload: error.response.data
			});
		}

		callback(false);
	})
};


/* 
    Get a users.
*/
export const getUser = (userId, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/users/${userId}`, {
		method: "get"
	}).then(res => {
		dispatch({
			type: GET_USER,
			payload: res.data.user
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

/* 
    Get a list of users for a route.
*/
export const getUsersForRoute = (routeId, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/routes/${routeId}/users`, {
		method: "get"
	}).then(res => {
		dispatch({
			type: GET_USERS_FOR_ROUTE,
			payload: res.data.usersForRoute
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

/* 
    Assign a user to route(s).
*/
export const assignToRoutes = (userId, routeIds, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/users/${userId}/routes`, {
		method: "post",
		data: routeIds
	}).then(res => {
		dispatch({
			type: ASSIGN_USER_TO_ROUTES,
			payload: res.data
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

/* 
    Assign a users to a route.
*/
export const assignUsersToRoute = (userIds, routeId, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/routes/${routeId}/users`, {
		method: "post",
		data: userIds
	}).then(_ => {
		dispatch({
			type: ASSIGN_USERS_TO_ROUTE,
			payload: { userIds, routeId }
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};


/* 
    Remove a user from route(s).
*/
export const removeFromRoutes = (userId, routeIds, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/users/${userId}/routes`, {
		method: "delete",
		data: routeIds
	}).then(_ => {
		dispatch({
			type: REMOVE_USER_FROM_ROUTES,
			payload: { userId, routeIds }
		});

		callback(true);
	}).catch((error) => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	})
};

export const removeUsersFromRoutes = (userIds, routeIds, activeRouteId, callback) => dispatch => {
	adalApiFetch(Axios, `${API_CONFIG.URL}/users/routes`, {
		method: "delete",
		data: { routeIds, userIds }
	}).then(_ => {
		dispatch({
			type: REMOVE_USERS_FROM_ROUTES,
			payload: { userIds, routeIds, activeRouteId }
		});

		callback(true);
	}).catch(error => {
		console.log(`Exception Occurred: ${error}`);
		callback(false);
	});
};
